@if (isImpersonating) {
    <div
        class="alert alert-warning alert-dismissible fade show m-0 text-center"
        role="alert"
        style="position: fixed; top: 0; left: 0; right: 0; z-index: 1051; border-radius: 0">
        <fa-icon class="mr-2" [icon]="['fas', 'exclamation-triangle']"></fa-icon>
        <strong>{{ 'You are currently logged in as' | translate }}: {{ currentUser?.userName }}</strong>
        <button
            class="btn btn-sm btn-warning ml-3"
            kendoTooltip
            [title]="'Switch back to your account' | translate"
            (click)="exitImpersonation()">
            <fa-icon [icon]="['fas', 'sign-out-alt']"></fa-icon>
        </button>
    </div>
}

<ngx-loading-bar color="#fff" ref="router" [height]="'4px'" [includeSpinner]="false"></ngx-loading-bar>
<ngx-loading-bar color="#fff" ref="http" [height]="'4px'" [includeSpinner]="false"></ngx-loading-bar>
<div kendoDialogContainer></div>

@if (setupStatus) {
    <app-header (toggleSidebar)="sidebar.toggle()"></app-header>
}

<app-sidebar #sidebar [ngStyle]="{ display: !isAuthenticated ? 'none' : 'block' }"></app-sidebar>

<main [ngStyle]="{ 'margin-left': getMainContentMargin(sidebar.isCollapsed) }">
    <div class="container-fluid px-0 px-sm-2 py-3 mt-4 mt-sm-5">
        <router-outlet></router-outlet>
    </div>
    <router-outlet name="print"></router-outlet>
</main>
